/**
 * Book Fanar product-video lightbox.
 *
 * Opens on any [data-bf-video-type] trigger (card badge, video-carousel card),
 * plays mp4 / youtube / vimeo uniformly, and calls the theme's own
 * pauseAllMedia() (global.js) so it participates in the same "only one video
 * plays at a time" contract as every other player in the theme.
 *
 * Deliberately self-contained instead of reusing fancybox.js / halo-video-popup.liquid:
 * both of those are shaped for youtube/vimeo only and route mp4 through a brittle
 * URL scrape. This file needs none of that -- bf-product-video.liquid already
 * resolves a clean src per type.
 */
(function () {
    'use strict';

    var overlay = null;
    var lastFocused = null;

    function closeLabel() {
        return document.documentElement.lang === 'ar' ? 'إغلاق' : 'Close';
    }

    function buildOverlay() {
        var el = document.createElement('div');
        el.className = 'bf-video-lightbox';
        el.setAttribute('role', 'dialog');
        el.setAttribute('aria-modal', 'true');
        el.innerHTML =
            '<div class="bf-video-lightbox__backdrop" data-bf-video-close></div>' +
            '<div class="bf-video-lightbox__panel">' +
            '<button type="button" class="bf-video-lightbox__close" data-bf-video-close aria-label="' + closeLabel() + '">&times;</button>' +
            '<div class="bf-video-lightbox__media"></div>' +
            '</div>';
        document.body.appendChild(el);
        return el;
    }

    function youtubeEmbed(id) {
        var iframe = document.createElement('iframe');
        iframe.className = 'js-youtube';
        iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&enablejsapi=1';
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('frameborder', '0');
        return iframe;
    }

    function vimeoEmbed(id) {
        var iframe = document.createElement('iframe');
        iframe.className = 'js-vimeo';
        iframe.src = 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1';
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('frameborder', '0');
        return iframe;
    }

    function mp4Embed(src, poster) {
        var video = document.createElement('video');
        video.className = 'js-video';
        video.src = src;
        if (poster) video.poster = poster;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        return video;
    }

    function openVideo(trigger) {
        var type = trigger.getAttribute('data-bf-video-type');
        var src = trigger.getAttribute('data-bf-video-src');
        var poster = trigger.getAttribute('data-bf-video-poster');
        if (!type || !src) return;

        if (typeof window.pauseAllMedia === 'function') {
            window.pauseAllMedia();
        }

        lastFocused = document.activeElement;
        overlay = buildOverlay();

        var mediaHost = overlay.querySelector('.bf-video-lightbox__media');
        var el;
        if (type === 'youtube') {
            el = youtubeEmbed(src);
        } else if (type === 'vimeo') {
            el = vimeoEmbed(src);
        } else {
            el = mp4Embed(src, poster);
        }
        mediaHost.appendChild(el);

        document.body.classList.add('bf-video-lightbox-open');
        requestAnimationFrame(function () {
            overlay.classList.add('is-open');
        });

        overlay.querySelector('.bf-video-lightbox__close').focus();
        document.addEventListener('keydown', onKeydown);
    }

    function closeVideo() {
        if (!overlay) return;

        if (typeof window.pauseAllMedia === 'function') {
            window.pauseAllMedia();
        }

        var el = overlay;
        overlay = null;
        document.body.classList.remove('bf-video-lightbox-open');
        document.removeEventListener('keydown', onKeydown);
        el.parentNode.removeChild(el);

        if (lastFocused && typeof lastFocused.focus === 'function') {
            lastFocused.focus();
        }
        lastFocused = null;
    }

    function onKeydown(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            closeVideo();
            return;
        }
        if (event.key === 'Tab' && overlay) {
            var focusable = overlay.querySelectorAll('button, [href], iframe, video, [tabindex]:not([tabindex="-1"])');
            if (!focusable.length) return;
            var first = focusable[0];
            var last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }
    }

    document.addEventListener('click', function (event) {
        var closeTrigger = event.target.closest('[data-bf-video-close]');
        if (closeTrigger) {
            event.preventDefault();
            closeVideo();
            return;
        }

        var trigger = event.target.closest('[data-bf-video-type]');
        if (trigger) {
            event.preventDefault();
            openVideo(trigger);
        }
    });

    document.addEventListener('keydown', function (event) {
        var trigger = event.target.closest('[data-bf-video-type]');
        if (trigger && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            openVideo(trigger);
        }
    });
})();
